import React, { useEffect } from "react";
import { connect } from "react-redux";
import PowerBiScreen from "../screens/PowerBiScreen";
import get from "../../utils/get";
import * as actions from "../actions/data";

const PowerBiContainer = (props) => {
  useEffect(() => {
    props.getAccesToken();
    // eslint-disable-next-line
  }, []);
  return <PowerBiScreen {...props} />;
};

const mapStateToProps = (state) => ({
  isLoading: get(state, "test.access.isLoading"),
  accessToken: get(state, "test.access.token"),
});

const mapActionsToProps = { ...actions };

export default connect(mapStateToProps, mapActionsToProps)(PowerBiContainer);
